export default __webpack_public_path__ + "static/media/LoginPageBG.6be55f9a.png";